import {Injectable} from '@angular/core';
import 'rxjs/add/observable/of';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {BaseService} from './base.service';

@Injectable()
export class EscolaService extends BaseService {

  getTrilha(): any {
    return this.http.get(this.baseUrl + '/api/v2/client/trilha', {headers: this.getHeader()});
  }

  getTrilhaInfo(): any {
    return this.http.get(this.baseUrl + '/api/v2/client/trilhaInfo', {headers: this.getHeader()});
  }

  registerNewProgress(current: number, trailId: number): Observable<any> {
    return this.http.post(
      this.baseUrl + '/api/v2/client/progresso/item/post?current='
      + current + '&item_id='
      + trailId,
      {},
      {headers: this.getHeader()}
    );
  }

  getProgressByTrailId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + '/api/v2/client/progresso/item/' + id,
      {headers: this.getHeader()});
  }

  getStepByTrail(trailId: number): Observable<any> {
    return this.http.get(this.baseUrl + '/api/v2/client/trilha/etapa/item/' + trailId,
      {headers: this.getHeader()});
  }

  getHeader(): any {
    const token = sessionStorage.getItem('token');
    if (token) {
      const headerOptions = {
        'Authorization': token,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      };
      return new HttpHeaders(headerOptions);
    }
  }

  getFormUrlEncoded(toConvert) {
    const formBody = [];
    for (const property of toConvert) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(toConvert[property]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    return formBody.join('&');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/escola.service.ts